import { useEffect } from 'react';

// แทนที่ banner "message"/"setMessage" ที่แต่ละหน้าเคยวางไว้บนสุดของหน้า (ต้องเลื่อน
// จอขึ้นไปดู) ด้วยข้อความกลางจอที่หายเองอัตโนมัติ — สีเขียว/แดงใช้ค่าเดิมที่ซ้ำกันอยู่แล้ว
// ใน BuffetPricing.jsx/PrinterSettings.jsx/CategoryManagement.jsx
export default function Toast({ message, onDismiss, duration = 3000 }) {
  const isSuccess = message?.type === 'success';

  // error หายเองใน 3 วิเท่ากับ success เดิม เจอเคสจริงที่คนกดบันทึกตอนเน็ตมีปัญหา
  // ชั่วครู่ toast แดงเด้งแล้วหายไปก่อนจะทันสังเกต เข้าใจผิดว่าบันทึกสำเร็จ ทั้งที่ค่าเดิม
  // ยังค้างอยู่ใน DB — error เลยต้องค้างจนกว่าจะกดปิดเอง ส่วน success ยังหายเองได้เหมือนเดิม
  useEffect(() => {
    if (!message || !isSuccess) return;
    const t = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(t);
  }, [message, isSuccess, duration, onDismiss]);

  if (!message) return null;
  return (
    <div
      onClick={!isSuccess ? onDismiss : undefined}
      style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        zIndex: 3000, padding: '1rem 1.75rem', borderRadius: '10px', fontWeight: 600,
        boxShadow: '0 10px 30px rgba(0,0,0,0.4)', textAlign: 'center',
        // width ต้องกำหนดตรงนี้ (ไม่ใช่แค่ maxWidth) — ".content > div > *" ใน index.css บังคับ
        // width: 100% กับลูกโดยตรงของหน้าทุกหน้า (กันตารางล้นจอ) แต่ดันเผลอจับ Toast (fixed
        // position ลอยกลางจอ) ไปด้วยเพราะมันก็เป็นลูกโดยตรงเหมือนกัน กลายเป็นแถบยาวเกือบเต็ม
        // ความกว้างจอทุกหน้าที่เรียก Toast — inline style ชนะ class เสมอ (ไม่มี !important ฝั่งนั้น)
        // fit-content คืนพฤติกรรมเดิมคือกล่องเล็กพอดีข้อความ ส่วน maxWidth ยังกันข้อความยาวล้นจอ
        width: 'fit-content', maxWidth: '90vw',
        whiteSpace: 'pre-line',
        // พื้นหลังต้องทึบตัน ไม่ใช่โปร่งใส — เดิม success ใช้ rgba(...,0.15) ทำให้ตัวอักษร/ปุ่ม
        // ของ content ข้างหลัง (เช่นการ์ดโต๊ะที่เรียงหนาแน่นในหน้า table-management) ทะลุขึ้นมา
        // ปนกับข้อความ Toast ดูเหมือนป๊อปอัพพัง — error ใช้สีทึบตันอยู่แล้วไม่มีปัญหานี้
        background: isSuccess ? '#14261c' : '#2a1517',
        border: isSuccess ? '1px solid var(--ok)' : '1px solid #8a2f33',
        color: isSuccess ? 'var(--ok)' : 'var(--danger)',
        cursor: !isSuccess ? 'pointer' : 'default'
      }}
    >
      {isSuccess ? '✅' : '❌'} {message.text}
      {!isSuccess && (
        <div style={{ fontSize: '0.75rem', fontWeight: 400, marginTop: '0.35rem', opacity: 0.75 }}>
          แตะเพื่อปิด
        </div>
      )}
    </div>
  );
}
